import { api, apiUrl } from './api';

export interface Campaign {
  id: string;
  type: string;
  title: string;
  body: string;
  imageKey: string | null;
  audience: string;
  audienceIds: string[];
  sendEmail: boolean;
  sendSms: boolean;
  schedule: string;          // Now | Once | Recurring
  scheduledAt: string | null;
  status: string;            // Draft | Scheduled | Sent | Cancelled
  recipientCount: number;
  createdAt: string;
  sentAt: string | null;
}

export const CAMPAIGN_TYPES = [
  'Birthday', 'Festival', 'Condolence', 'Achievement', 'ExamResult',
  'PtmReminder', 'Holiday', 'Emergency', 'WeatherAlert', 'BusDelay', 'SportsWin', 'Custom',
] as const;

export const AUDIENCES = [
  'AllFamilies', 'AllStaff', 'ClassFamilies', 'RouteFamilies', 'Everyone',
] as const;

export interface CreateCampaign {
  institutionId: string;
  type: string;
  title: string;
  body: string;
  imageKey?: string | null;
  audience: string;
  audienceIds?: string[] | null;
  sendEmail: boolean;
  sendSms: boolean;
  schedule: string;           // Now | Once | Recurring
  scheduledAt?: string | null;
}

export const campaignsApi = {
  list: (opts?: { institutionId?: string; status?: string; type?: string }) => {
    const q = new URLSearchParams();
    if (opts?.institutionId) q.set('institutionId', opts.institutionId);
    if (opts?.status) q.set('status', opts.status);
    if (opts?.type) q.set('type', opts.type);
    const qs = q.toString();
    return api.get<Campaign[]>(`/api/campaigns/${qs ? `?${qs}` : ''}`);
  },
  get: (id: string) => api.get<Campaign>(`/api/campaigns/${id}`),
  create: (b: CreateCampaign) => api.post<Campaign>('/api/campaigns/', b),
  update: (id: string, b: Omit<CreateCampaign, 'institutionId'>) => api.put<Campaign>(`/api/campaigns/${id}`, b),
  cancel: (id: string) => api.post<Campaign>(`/api/campaigns/${id}/cancel`),
  send: (id: string) => api.post<Campaign>(`/api/campaigns/${id}/send`),

  // multipart image upload — returns the storage key
  uploadImage: async (file: File): Promise<string> => {
    const fd = new FormData();
    fd.append('file', file);
    const res = await fetch(apiUrl('/api/campaigns/image'), {
      method: 'POST',
      headers: { Authorization: `Bearer ${localStorage.getItem('eduvora.access') ?? ''}` },
      body: fd,
    });
    if (!res.ok) throw new Error('Image upload failed');
    const data = (await res.json()) as { imageKey: string };
    return data.imageKey;
  },

  imageUrl: (key: string) => apiUrl(`/api/campaigns/image/${key}`),
};
